export default "__VITE_ASSET__Dspf0omt__"